// Główny plik zarządzający tłumaczeniami
import { pl } from './pl';
import { en } from './en';
import { adminPl } from './admin/pl';
import { adminEn } from './admin/en';

const DEFAULT_LANGUAGE = 'pl';

export const userTranslations = {
  pl,
  en
};

export const adminTranslations = {
  pl: adminPl,
  en: adminEn
};

export const translations = {
  pl: { ...pl, admin: adminPl },
  en: { ...en, admin: adminEn }
};

const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

const deepMerge = (target, source) => {
  if (!isObject(target) || !isObject(source)) {
    return source
  }

  const result = { ...target }
  Object.keys(source).forEach((key) => {
    if (isObject(source[key]) && isObject(result[key])) {
      result[key] = deepMerge(result[key], source[key])
    } else {
      result[key] = source[key]
    }
  })
  return result
}

const getStoredObject = (storageKey) => {
  if (typeof window === 'undefined') {
    return {}
  }
  try {
    const raw = localStorage.getItem(storageKey)
    if (!raw) {
      return {}
    }
    const parsed = JSON.parse(raw)
    return isObject(parsed) ? parsed : {}
  } catch (error) {
    return {}
  }
}

export const getTranslation = (language = DEFAULT_LANGUAGE) => {
  const customUserTranslations = getStoredObject('ahpCustomTranslations')
  const customAdminTranslations = getStoredObject('ahpCustomAdminTranslations')
  const userBase = userTranslations[language] || userTranslations[DEFAULT_LANGUAGE]
  const adminBase = adminTranslations[language] || adminTranslations[DEFAULT_LANGUAGE]
  const userMerged = deepMerge(userBase, customUserTranslations[language] || {})
  const adminMerged = deepMerge(adminBase, customAdminTranslations[language] || {})
  return {
    ...userMerged,
    admin: adminMerged
  }
};

export const setLanguage = (language) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('ahpLanguage', language || DEFAULT_LANGUAGE)
  }
  return language || DEFAULT_LANGUAGE;
};

export const getLoginLanguage = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LANGUAGE
  }
  return localStorage.getItem('ahpLoginLanguage') || DEFAULT_LANGUAGE
}

export const setLoginLanguage = (language) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('ahpLoginLanguage', language || DEFAULT_LANGUAGE)
  }
  return language || DEFAULT_LANGUAGE
}

const storedLanguage = typeof window !== 'undefined'
  ? (localStorage.getItem('ahpLanguage') || DEFAULT_LANGUAGE)
  : DEFAULT_LANGUAGE
export default getTranslation(storedLanguage);
